import { Box } from '@mantine/core';
import { ReactNode } from 'react';

interface StrikeIconWrapperProps {
  size: number;
  children: ReactNode;
}

/**
 * Negation of the base icon (like FiEye → FiEyeOff)
 */
export default function StrikeIconWrapper({
  size,
  children,
}: StrikeIconWrapperProps) {
  return (
    <Box pos="relative" display="inline-flex">
      {children}
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        style={{ position: 'absolute', inset: 0 }}
        aria-hidden
      >
        <line
          x1="3"
          y1="3"
          x2="21"
          y2="21"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
    </Box>
  );
}
